import { render, staticRenderFns } from "./scholarAnalysisDetails.vue?vue&type=template&id=04d5504b&scoped=true&"
import script from "./scholarAnalysisDetails.vue?vue&type=script&lang=js&"
export * from "./scholarAnalysisDetails.vue?vue&type=script&lang=js&"
import style0 from "./scholarAnalysisDetails.vue?vue&type=style&index=0&id=04d5504b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d5504b",
  null
  
)

export default component.exports